import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as React from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider, useAuth } from "@/auth/AuthContext";
import { LoginPage } from "@/components/LoginPage";
import { UsageDashboard } from "@/components/UsageDashboard";
import "@/index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      gcTime: 5 * 60 * 1000,
    },
  },
});

function Gate() {
  const { token } = useAuth();
  return token ? <UsageDashboard /> : <LoginPage />;
}

const App: React.FC = () => (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Gate />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
